module.exports = __webpack_public_path__ + "static/media/bigeclipse.ecb2be24.svg";